// oneHeight
export default function oneHeightElements(element) {
    let maxheight = 0; // максимальная высота, первоначально 0
    let elements = document.querySelectorAll(element); // получаем массив колонок (всех элементов класса column)
    for (let i = elements.length - 1; i >= 0; i--) { // прокручиваем каждую колонку в цикле
        if( elements[i].offsetHeight > maxheight ) {
            maxheight = elements[i].offsetHeight; // устанавливаем новое значение максимальной высоты
        }
    }
    for (let i = elements.length - 1; i >= 0; i--) {
        elements[i].style.height = `${maxheight}px`; // устанавливаем высоту каждой колонки равной максимальной
    }
}